import CompanySettings from './CompanySettings';

export default CompanySettings;



